import { render, staticRenderFns } from "./NewTranslationModal.vue?vue&type=template&id=28406482&lang=pug&"
import script from "./NewTranslationModal.vue?vue&type=script&lang=js&"
export * from "./NewTranslationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports